import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader-page',
  templateUrl: './loader-page.component.html',
  styleUrls: ['./loader-page.component.scss']
})
export class LoaderPageComponent implements OnInit {
  @Input() isloading :Boolean;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/loader-page/loader-page.component.ts